package com.rainbowclubs.rainbow.domain.use_cases.membership

import com.rainbowclubs.rainbow.data.models.MembershipsPageResponse
import com.rainbowclubs.rainbow.domain.repositories.MembershipRepository

class GetExistingMembershipsUseCase(
    private val membershipRepository: MembershipRepository,
) {
    suspend operator fun invoke(
        clubId: String,
        page: Int,
        limit: Int,
        search: String? = null,
    ): Result<MembershipsPageResponse> {
        return membershipRepository.getExistingMemberships(
            clubId = clubId,
            page = page,
            limit = limit,
            search = search,
        )
    }
}
